import { createUseStyles } from 'react-jss'
import { ThemeDefinition } from '../../../../data/types/ThemeDefinition'

const useStyles = createUseStyles((theme: ThemeDefinition) => ({
  scrollOrbContainer: {
    position: 'fixed',
    bottom: '20px',
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center'
  },

  scrollOrb: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.primaryColor.default,
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    '& > svg': {
      width: '25%'
    }
  }
}))

export default useStyles
